import Triage from './Triage';

export default Triage;
